import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import '@/assets/plugins/animate/animate.min.css';
import '@/main.scss';

import { createApp } from 'vue/dist/vue.esm-bundler';
import store from '@/store';
import App from '@/App.vue';
import router from '@/router';
import axios, { AxiosInstance } from 'axios';
import VueAxios from 'vue-axios';
import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import { FontAwesomeIcon } from '@/assets/plugins/font-awesome';
import Toaster from '@meforma/vue-toaster';
import VueTippy from 'vue-tippy';
import VueSweetalert2 from 'vue-sweetalert2';
import { vfmPlugin } from 'vue-final-modal';
import VueCountdown from '@chenfengyuan/vue-countdown';
import app_mixin from "./mixin.js";
import lib from '@/lib';

const app = createApp(App);
const metaManager = createMetaManager();

window['appInstance'] = null;
window['appComponent'] = null;
window['storeInstance'] = null;

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$store = store;
//app.config.productionTip = false;
//app.config.debug = true;
//app.config.devtools = true;
app.use(router);
app.use(store);
app.use(VueAxios, axios);
app.use(store.state.app.i18n);
app.use(metaManager);
app.use(Toaster, {
	duration: 3000,
	position: 'bottom-right',
});
app.use(VueSweetalert2);
app.use(VueTippy, {
	directive: 'tippy', // => v-tippy
	component: 'tippy', // => <tippy/>
	componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
	defaultProps: {
		placement: 'auto-end',
		allowHTML: true,
		theme: 'material',
		maxWidth: 400,
		arrow: true,
		delay: [200, 0],
		duration: 0,
		//appendTo: 'parent',
    },
	content: (reference) => reference.getAttribute('title') || reference.getAttribute('content'),
});
app.use(vfmPlugin);
app.component(VueCountdown.name, VueCountdown);
app.component('font-awesome-icon', FontAwesomeIcon);
lib.addMixin(app_mixin);
app.mount('#app');

window['lib'] = lib;
window['axios'] = axios;

window['appInstance'] = app;
window['storeInstance'] = store;
